import conventionalTrackingRequest from '@/models/conventional/trackingRequest'

export default {
  namespaced: true,
  state: {
    currentPage: 1,
    count: 0
  },
  actions: {
    async list ({ dispatch, state }, params) {
      console.log(params)
      return dispatch('list', {modelClass: conventionalTrackingRequest, params: params}, { root: true })
        .then(response => {
          state.count = response.count
          return response.results
        })
        .catch(error => { throw error })
    },
    async retrieve ({ dispatch, state }, id) {
      return dispatch('retrieve', { modelClass: conventionalTrackingRequest, id: id }, { root: true })
        .then(response => { return response })
        .catch(error => { throw error })
    },
    async save ({ dispatch, state }, data) {
      return dispatch('save', { modelClass: conventionalTrackingRequest, data: data, duration: 7000 }, { root: true })
        .then(response => { state.object = response })
        .catch(error => { throw error })
    },
    async patch ({ dispatch, state }, data) {
      var id = data.id
      data.id = undefined
      return dispatch('partialUpdate', { modelClass: conventionalTrackingRequest, id: id, data: data, duration: 7000 }, { root: true })
        .then(response => { state.object = response })
        .catch(error => { throw error })
    },
    async export ({ dispatch, state }, params) {
      return dispatch(
        'download',
        {
          method: 'get',
          params: params,
          url: `conventional-tracking-requests/export`
        }, { root: true })
        .then(response => { return response })
        .catch(error => { throw error })
    },
    async transition ({ dispatch, state }, data) {
      return dispatch('save', {
        action: 'transition',
        modelClass: conventionalTrackingRequest,
        id: data.id,
        data: { 'status': data.newStatus }
      }, { root: true })
        .then(response => { return response })
        .catch(error => { throw error })
    }
  },
  getters: {
    objects (state) { return state.objects }
  }
}



// WEBPACK FOOTER //
// ./src/store/conventional/trackingRequest.js